export class SubticketTypeField {
  public Id: number;
  public Code: string;
  public Name: string;
  public Type: string;
  public Mandatory: boolean;
  public SubticketTypeId: number;
}
